import React from 'react'
import * as C from "../componentsM/index";

const Cafeteria = () => {
    return (
        <>

            <C.Hero title={"CAFETERIA"} image={"/hero/17.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <h1>The limitation of physical space in the temporary premises restricts the cafeteria services at the school. At the Primary Campus, the school provides a healthy snack to the Pre Primary students. However, PYP 1 to PYP 5 students are encouraged to bring a healthy snack from home.</h1>
                    <h1>At the secondary campus a limited space has been commissioned to caterers to meet minimal needs for student and staff lunch. Students and staff are required to purchase their lunch or snacks directly from the vendor.</h1>

                </div> 


            </section>

        </>
    )
}

export default Cafeteria